import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
// import ReactTable from 'react-table';
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1918() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    const [Borrow1918data, setBorrow1918data] = useState([]);
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() +543)

    async function GetV1918() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1918", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow1918data(data.dataenum)

    }

    /* async function GetV1918() {
         const response1918 = await fetch("/api/BorrowReports/getV1918")
         const Borrow1918data = await response1918.json()
         setBorrow1918data(Borrow1918data.dataenum);
         // console.log(Borrow1918data)
     }*/

    const [Re1918yeardata, setRe1918yeardata] = React.useState([]);
    async function getR1918year() {
        const res = await fetch("/api/BorrowReports/getyear1918")
        const Re1918yeardata = await res.json()
        setRe1918yeardata(Re1918yeardata.dataenum)
        // console.log(Re1918yeardata)
    }


     
    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ที่', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่คำขอ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่สัญญา', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผู้ขอกู้', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ประเภทกิจการ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนลูกจ้าง', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนหลักสูตร', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนรุ่น', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายชื่อหลักสูตร', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สาขาอาชีพ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่เริ่มฝึกอบรม/ทดสอบฯ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เดือนที่จบการฝึกหลักสูตรสุดท้าย', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'พ.ศ. ที่จบการฝึกหลักสูตรสุดท้าย', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนลูกจ้างที่ฝึกอบรม(คน)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วงเงิน(บาท)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รวมวงเงินที่ได้รับการอนุมัติ(บาท)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ครั้งที่และ ว/ด/ป ที่อนุกรรมการพิจารณาการให้กู้ยืมเงินฯ อนุมัติ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สพร./สพน.', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลื่อนฝึกครั้งที่ 1', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, 
    //         { text: 'เหตุผลแจ้งเลื่อน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ส่งรายงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลื่อนฝึกครั้งที่ 2', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เหตุผลแจ้งเลื่อน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ส่งรายงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลื่อนฝึกครั้งที่ 3', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เหตุผลแจ้งเลื่อน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ส่งรายงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วิธีดาารติดตาม', colSpan: 7, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, { text: 'ดำเนินการฝึกอบนม/ทดสอบ', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'ปัญหาที่พบ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อเสนอ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายงาย กย.8', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ยังไม่ถึงกำหนดฝึก', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }],

    //     [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, 
    //         {}, { text: 'ลงวันที่แจ้งขอเลื่อนจากผู้กู้ยืม', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ลงวันที่แจ้งขอเลื่อนจากผู้กู้ยืม', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {text: 'ลงวันที่แจ้งขอเลื่อนจากผู้กู้ยืม', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'เข้าตรวจเยี่ยม', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'ผ่านโซเชียล', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {text: 'ภาพถ่าย', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'วิดีโอ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'อื่นๆ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'ตรง', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'ไม่ตรง', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}],

    //     [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, 
    //         {}, {}, {}, {}, {}, {}, {}, {}, {}, {text: 'เฟสบุ๊ก', fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'ยูทูป', fillColor: '#cccccc', bold: true, alignment: 'center' }, {text: 'สไกป์', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}],

    //     [{ text: 'กย.3', colSpan: 19, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: 'กย.8', colSpan: 22, fillColor: '#cccccc', bold: true, alignment: 'center' }, 
    //         { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}, { text: '', fillColor: '#cccccc'}]];
    //     Borrow1918data.forEach(function (item, i) {
    //          var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.borrowNumber, alignment: 'right' }, { text: item.contactNumber, alignment: 'right' }, { text: item.employee, alignment: 'right' }, { text: item.businessType, alignment: 'right' }, { text: item.personTotal, alignment: 'right' }, { text: item.course, alignment: 'right' }, { text: item.class, alignment: 'right' }, { text: item.courseName, alignment: 'right' }, { text: item.lawOccupationName, alignment: 'right' }, { text: item.startDateTrain, alignment: 'right' }, { text: item.endDateTrain, alignment: 'right' }, {}, {}, { text: item.personTotal, alignment: 'right' }, {}, { text: item.amountApprove, alignment: 'right' }, { text: 'ครั้งที่ ' + item.meetingNo + ' / ' + item.meetingDate, alignment: 'right' }, { text: item.approveOfficerBy, alignment: 'right' }, { text: item.trainClassID, alignment: 'right' }, 
    //                     { text: item.remarkTrain, alignment: 'right' }, { text: item.createDateTrain, alignment: 'right' }, { text: item.trainClassID, alignment: 'right' }, { text: item.remarkTrain, alignment: 'right' }, { text: item.createDateTrain, alignment: 'right' }, { text: item.trainClassID, alignment: 'right' }, { text: item.remarkTrain, alignment: 'right' }, { text: item.createDateTrain, alignment: 'right' }, { text: item.follower, alignment: 'right' }, { text: item.facebook, alignment: 'right' }, { text: item.youtube, alignment: 'right' }, { text: item.skype, alignment: 'right' }, {}, {}, {}, { text: item.onTime, alignment: 'right' }, { text: item.notOnTime, alignment: 'right' }, { text: item.issue, alignment: 'right' }, { text: item.remarkFollow, alignment: 'right' }, {}, {}]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'ทะเบียนข้อมูลสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน ตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545', style: 'header', alignment: 'center', bold: true, fontSize: 20 },
    //             Borrow1918data.map((item) => ({ text: 'ปีงบประมาณ พ.ศ.' + thYearSelected, style: 'header', bold: true, alignment: 'center', fontSize: 16 })),
    //             {
    //                 table: {
    //                     widths: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 
    //                         10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1918')
    // }

    useEffect(() => {
        GetV1918()
        getR1918year()
    }, [thYearSelected])
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 style={{ paddingTop: '1px' }} className='mt-3 text-center'>
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "10%", paddingTop: '15px', fontSize: '1.60rem' }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1918yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}

                    </Input>
                </div> */}
                 <div className='d-flex justify-content-center align-items-center'>
                   
                    <span className='header-select-year mx-3'>ปีงบประมาณ พ.ศ.</span>
                    <Input 
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1918yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1918?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1918?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1918?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1918?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>


                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="3" className=' text-center'>
                                    ที่
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    เลขที่คำขอ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    เลขที่สัญญา
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    ผู้ขอกู้
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    ประเภทกิจการ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    จำนวนลูกจ้าง
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    จำนวนหลักสูตร
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    จำนวนรุ่น
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    รายชื่อหลักสูตร
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    สาขาอาชีพ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    วันทีี่เริ่มฝึกอบรม/ทดสอบ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    เดือนที่จบการฝึกหลักสูตรสุดท้าย
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    พ.ศ. ที่จบการฝึกหลักสูตรสุดท้าย
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    จำนวนลูกจ้างที่ฝึกอบรม(คน)
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    รวมวงเงินที่ขอกู้(บาท)
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    วงเงินที่ได้รับการอนุมัติ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    ครั้งที่ และ ว/ด/ป ที่อนุกรรมการพิจารณาการให้กู้ยืมเงินฯอนุมัติ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    สพร./สนพ.
                                </th>
                                <th scope="row" rowSpan="3" className=' text-center'>
                                    เลื่อนฝึกครั้งที่1
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    เหตุผลแจ้งเลื่อน
                                </th>
                                <th className=' text-center'>
                                    ส่งรายงาน
                                </th>
                                <th scope="row" rowSpan="3" className=' text-center'>
                                    เลื่อนฝึกครั้งที่2
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    เหตุผลแจ้งเลื่อน
                                </th>
                                <th className=' text-center'>
                                    ส่งรายงาน
                                </th>
                                <th scope="row" rowSpan="3" className=' text-center'>
                                    เลื่อนฝึกครั้งที่3
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    เหตุผลแจ้งเลื่อน
                                </th>
                                <th className=' text-center'>
                                    ส่งรายงาน
                                </th>
                                <th colSpan="7" className=' text-center'>
                                    วิธีการติดตาม
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    ดำเนินการฝึกอบรม/ทดสอบ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    ปัญหาที่พบ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    ข้อเสนอ
                                </th>
                                <th rowSpan="4" className=' text-center'>
                                    รายงาน กย.8
                                </th>
                                <th rowSpan="4" className=' text-center'>
                                    ยังไม่ถึงกำหนดฝึก
                                </th>
                            </tr>
                            <tr>
                                <th rowSpan="2" className='text-center'>
                                    ลงวันที่แจ้งขอเลื่อนจากผู้กู้ยืม
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ลงวันที่แจ้งขอเลื่อนจากผู้กู้ยืม
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ลงวันที่แจ้งขอเลื่อนจากผู้กู้ยืม
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    เข้าตรวจเยี่ยม
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ผ่านโซเชียล
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ภาพถ่าย
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    วีดีโอ
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    อื่นๆ
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ตรง
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ไม่ตรง
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    เฟสบุ๊ก
                                </th>
                                <th className='text-center'>
                                    ยูทูป
                                </th>
                                <th className='text-center'>
                                    สไกป์
                                </th>
                            </tr>
                            <tr>
                                <th colSpan="19" className='text-center'>
                                    กย.3
                                </th>
                                <th colSpan="23" className='text-center'>
                                    กย.8
                                </th>
                            </tr>
                        </thead>
                        <tbody> {Borrow1918data.map((item, i) => (
                            <tr>
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-end'>
                                    {item.borrowNumber}
                                </td>
                                <td className='text-end'>
                                    {item.contactNumber}
                                </td>
                                <td className='text-end'>
                                    {item.employee}
                                </td>
                                <td className='text-end'>
                                    {item.businessType}
                                </td>
                                <td className='text-end'>
                                    {item.personTotal}
                                </td>
                                <td className='text-end'>
                                    {item.course}
                                </td>
                                <td className='text-end'>
                                    {item.class}
                                </td>
                                <td className='text-end'>
                                    {item.courseName}
                                </td>
                                <td className='text-end'>
                                    {item.lawOccupationName}
                                </td>
                                <td className='text-end'>
                                    {item.startDateTrain}
                                </td>
                                <td className='text-end'>
                                    {item.endDateTrain}
                                </td>
                                <td className='text-end'>
                                    {item.endMountTrain}
                                </td>
                                <td className='text-end'>
                                    {item.endYearTrain}
                                </td>
                                <td className='text-end'>
                                    {item.personTotal}
                                </td>
                                <td className='text-end'>
                                    {item.amountApprove}
                                </td>
                                <td className='text-end'>
                                    {item.amountApprove}
                                </td>
                                <td className='text-end'>
                                    ครั้งที่ {item.meetingNo + ' / ' + item.meetingDate}
                                </td>
                                <td className='text-end'>
                                    {item.approveOfficerBy}
                                </td>
                                <td className='text-end'>
                                    {item.trainClassID}
                                </td>
                                <td className='text-end'>
                                    {item.remarkTrain}
                                </td>
                                <td className='text-end'>
                                    {item.createDateTrain}
                                </td>
                                <td className='text-end'>
                                    {item.trainClassID}
                                </td>
                                <td className='text-end'>
                                    {item.remarkTrain}
                                </td>
                                <td className='text-end'>
                                    {item.createDateTrain}
                                </td>
                                <td className='text-end'>
                                    {item.trainClassID}
                                </td>
                                <td className='text-end'>
                                    {item.remarkTrain}
                                </td>
                                <td className='text-end'>
                                    {item.createDateTrain}
                                </td>
                                <td className='text-end'>
                                    {item.follower}
                                </td>
                                <td className='text-end'>
                                    {item.facebook}
                                </td>
                                <td className='text-end'>
                                    {item.youtube}
                                </td>
                                <td className='text-end'>
                                    {item.skype}
                                </td>
                                <td className='text-center'>
                                    
                                </td>
                                <td className='text-end'>
                                    
                                </td>
                                <td className='text-end'>
                                    
                                </td>
                                <td className='text-end'>
                                    {item.onTime}
                                </td>
                                <td className='text-end'>
                                    {item.notOnTime}
                                </td>
                                <td className='text-end'>
                                    {item.issue}
                                </td>
                                <td className='text-end'>
                                    {item.remarkFollow}
                                </td>
                                <td className='text-end'>
                                    {item.specified}
                                </td>
                                <td className='text-end'>
                                    {item.notDue}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>



            </div>

        </Container>
    );


}